import { BonusEvent } from '@/models/bonusEvent';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

export function useParsedBonusEvents(events: BonusEvent[]): string {
  const { t } = useTranslation('common');

  return useMemo(() => {
    const parsedEvents: string = events
      ?.map(event =>
        event?.name?.includes('Sports') ? t('tab_sportsbook') : event?.name,
      )
      ?.join(', ');

    if (parsedEvents?.length > 1) {
      return `${parsedEvents} ${t('and_others')}`;
    }

    return parsedEvents;
  }, [events, t]);
}
